__turbopack_context__.v({
  "google-certificate-link": "google-certificate-ribbon-module-scss-module__otWSKa__google-certificate-link",
  "google-certificate-ribbon": "google-certificate-ribbon-module-scss-module__otWSKa__google-certificate-ribbon",
  "icon-google": "google-certificate-ribbon-module-scss-module__otWSKa__icon-google",
  "skeleton-icon": "google-certificate-ribbon-module-scss-module__otWSKa__skeleton-icon",
});
